import React from "react"
import zain from "../assets/icons/zain_logo.png"
import xgame from "../assets/icons/logo.png"
import subscribe from "../assets/icons/subscribe.png"
import './Subscribe.scss'
import {Link} from "react-router-dom"

function NotFound() {
    console.log('inside OTP container')
    return (
        <div className="container m-w">
            <div className="columns is-mobile">
                <div className="column is-full">
                    <div className="card">
                        <div className="card-content">
                            <figure className="image z-s m-1">
                                <img src={zain} alt="zain logo"/>
                            </figure>
                            <figure className="image l-s m-2">
                                <img src={xgame} alt="xgame logo"/>
                            </figure>
                            <figure className="image s-s m-5 pb-5">
                                <img src={subscribe} alt="subcribe icon"/>
                            </figure>
                            <div className="column has-text-centered">
                                <p>لم يتم العثور على الصفحة المطلوبة.</p>
                                <Link to="/" className="button is-rounded btn-main mt-3">اذهب الى المنزل</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound